import { defineMessage } from '@lingui/macro';

export const CrewMemberShiftTypeMessages = {
  DAY: defineMessage({ message: `Day` }),
  NIGHT: defineMessage({ message: `Night` }),
};

export const MilestoneStatusMessages = {
  UNCLAIMED: defineMessage({ message: `Unclaimed` }),
  CLAIMED: defineMessage({ message: `Claimed` }),
  APPROVED: defineMessage({ message: `Approved` }),
  UNAPPROVED: defineMessage({ message: `Unapproved` }),
  REJECTED: defineMessage({ message: `Rejected` }),
  BLOCKED: defineMessage({ message: `Blocked` }),
  PLANNED: defineMessage({ message: `Planned` }),
  UNPLANNED: defineMessage({ message: `Unplanned` }),
  BLOCK_RESOLVED: defineMessage({ message: `Block Resolved` }),
};

const READY_TO_WELD = 'READY_TO_WELD',
  VT_SENT_BACK = 'VT_SENT_BACK',
  BLOCKED = 'BLOCKED',
  FITUP_INSPECTION = 'FITUP_INSPECTION',
  CLAIMED = 'CLAIMED',
  ASSIGNED = 'ASSIGNED',
  VT_APPROVED = 'VT_APPROVED',
  SENT_BACK_TO_PIPING = 'SENT_BACK_TO_PIPING',
  UNPLANNED = 'UNPLANNED',
  UNASSIGNED = 'UNASSIGNED',
  FITUP_REQUESTED = 'FITUP_REQUESTED',
  REQUESTED = 'REQUESTED',
  REJECTED = 'REJECTED',
  APPROVED = 'APPROVED',
  PLANNED = 'PLANNED';

export const WeldStatusMessages = {
  [READY_TO_WELD]: defineMessage({ message: `Ready to Weld` }),
  [VT_SENT_BACK]: defineMessage({ message: `VT Sent Back` }),
  [BLOCKED]: defineMessage({ message: `Blocked` }),
  [FITUP_REQUESTED]: defineMessage({ message: `Fitup Requested` }),
  [FITUP_INSPECTION]: defineMessage({ message: `Fitup Inspection` }),
  [CLAIMED]: defineMessage({ message: `Claimed` }),
  [ASSIGNED]: defineMessage({ message: `Assigned` }),
  [VT_APPROVED]: defineMessage({ message: `VT Approved` }),
  [SENT_BACK_TO_PIPING]: defineMessage({ message: `Sent Back to Piping` }),
  [UNPLANNED]: defineMessage({ message: `Unplanned` }),
  [UNASSIGNED]: defineMessage({ message: `Unassigned` }),
};

export const FitupStatsSummaryMessage = {
  [REQUESTED]: defineMessage({ message: `Fitup Requested` }),
  [CLAIMED]: defineMessage({ message: `Claimed` }),
  [REJECTED]: defineMessage({ message: `Rejected` }),
  [APPROVED]: defineMessage({ message: `Approved` }),
  [BLOCKED]: defineMessage({ message: `Blocked` }),
};

export const InstallStatsSummaryMessage = {
  [UNPLANNED]: defineMessage({ message: `Unplanned` }),
  [PLANNED]: defineMessage({ message: `Planned` }),
  [CLAIMED]: defineMessage({ message: `Claimed` }),
  [REJECTED]: defineMessage({ message: `Rejected` }),
  [APPROVED]: defineMessage({ message: `Approved` }),
  [BLOCKED]: defineMessage({ message: `Blocked` }),
};
